import { createQueryKeys } from '@lukemorales/query-key-factory';

export const funds = createQueryKeys('funds', {
  fundFromOrigin: null,
});
